import { render } from "./Snackbar.vue?vue&type=template&id=5f270f02&scoped=true&ts=true"
import script from "./Snackbar.vue?vue&type=script&lang=ts"
export * from "./Snackbar.vue?vue&type=script&lang=ts"

import "./Snackbar.vue?vue&type=style&index=0&id=5f270f02&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f270f02"]])

export default __exports__